// extracted by mini-css-extract-plugin
export var card = "MiniCard-module--card--d428b";
export var cdsAssistiveText = "MiniCard-module--cds--assistive-text--9b748";
export var cdsHideFeedback = "MiniCard-module--cds--hide-feedback--cc3ad";
export var cdsShowFeedback = "MiniCard-module--cds--show-feedback--cffb0";
export var cdsSkeleton = "MiniCard-module--cds--skeleton--8c942";
export var cdsVisuallyHidden = "MiniCard-module--cds--visually-hidden--7ea74";
export var icon = "MiniCard-module--icon--719eb";
export var image = "MiniCard-module--image--ea7e9";
export var title = "MiniCard-module--title--1e7a7";
export var wrapper = "MiniCard-module--wrapper--bf409";